export const playing = 'mode:playing';
export const review = 'mode:review';
export const editing = 'mode:editing';
